import { render, staticRenderFns } from "./patientConclusion.vue?vue&type=template&id=278b0308&"
import script from "./patientConclusion.vue?vue&type=script&lang=js&"
export * from "./patientConclusion.vue?vue&type=script&lang=js&"
import style0 from "./patientConclusion.vue?vue&type=style&index=0&id=278b0308&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports